export default function AlignLeft() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 2H4C3.44688 2 3 1.55219 3 1C3 0.447812 3.44688 0 4 0H10C10.5531 0 11 0.447812 11 1C11 1.55219 10.5531 2 10 2ZM13 6H1C0.447812 6 0 5.55312 0 5C0 4.44688 0.447812 4 1 4H13C13.5531 4 14 4.44688 14 5C14 5.55312 13.5531 6 13 6ZM0 13C0 12.4469 0.447812 12 1 12H13C13.5531 12 14 12.4469 14 13C14 13.5531 13.5531 14 13 14H1C0.447812 14 0 13.5531 0 13ZM10 10H4C3.44688 10 3 9.55313 3 9C3 8.44687 3.44688 8 4 8H10C10.5531 8 11 8.44687 11 9C11 9.55313 10.5531 10 10 10Z" fill="currentColor" />
    </svg>
  )
}
